export const createSetValueAutomationEvent = (value, startTime) => {
    return { startTime, type: 'setValue', value };
};
//# sourceMappingURL=create-set-value-automation-event.js.map